import clipboardBuilder from '../shared/clipboard_builder.coffee'
$(->
  clipboardBuilder.build('.global-copy-button')
)
